import { COLOR } from '@/constants';

export default {
  color: COLOR
};
